import React from 'react';
const testimonials = [{
  name: 'Markus W.',
  role: 'Jugendtrainer, TSV München',
  stars: 5,
  text: 'Seit ich Basketball-Fix nutze, spare ich jede Woche mindestens 3 Stunden. Meine Spieler merken den Unterschied — das Training ist strukturierter und abwechslungsreicher als je zuvor.',
  timeAgo: 'vor 2 Wochen'
}, {
  name: 'Sandra K.',
  role: 'U14-Trainerin, SG Köln',
  stars: 5,
  text: 'Endlich ein System, das wirklich funktioniert! Die Übungen sind klar erklärt, die Grafiken kann ich direkt in der Halle zeigen. Mein Team hat in nur 4 Wochen riesige Fortschritte gemacht.',
  timeAgo: 'vor 5 Tagen'
}, {
  name: 'Thomas R.',
  role: 'Vereinstrainer, BC Stuttgart',
  stars: 5,
  text: 'Als Anfänger-Trainer war ich oft unsicher, was ich trainieren soll. Mit Basketball-Fix fühle ich mich wie ein Profi. Die Saisonplanung allein ist das Geld zehnmal wert.',
  timeAgo: 'vor 1 Woche'
}, {
  name: 'Julia M.',
  role: 'Schul-AG Leiterin, Hamburg',
  stars: 5,
  text: 'Ich leite eine Basketball-AG an einer Grundschule und hatte null Erfahrung. Dieses Paket hat mir den Einstieg so einfach gemacht — die Kinder lieben die neuen Übungen!',
  timeAgo: 'vor 3 Tagen'
}, {
  name: 'Stefan H.',
  role: 'U16-Coach, DBB-Lizenz C',
  stars: 5,
  text: 'Die didaktische Progression ist genial durchdacht. Vom Ballhandling bis zur Taktik — alles baut logisch aufeinander auf. Absolut empfehlenswert für jeden ambitionierten Trainer.',
  timeAgo: 'vor 10 Tagen'
}, {
  name: 'Andreas B.',
  role: 'Seniorentrainer, TV Dortmund',
  stars: 5,
  text: 'Ich trainiere seit 15 Jahren und dachte, ich hätte alles gesehen. Basketball-Fix hat mir trotzdem neue Impulse gegeben. Besonders die 101 Drills sind Gold wert.',
  timeAgo: 'vor 1 Woche'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-220">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.06) 0%, transparent 70%)'
    }} data-id="element-221"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-222">
        <div className="text-center mb-14" data-id="element-223">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-224">
            Was andere Trainer sagen
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-225">
            Über 1.200 verifizierte Bewertungen von Coaches aus der DACH-Region.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-226">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 flex flex-col gap-4 hover:border-primary/30 transition-colors group relative overflow-hidden" data-id="element-227">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-228"></div>

              {/* Stars */}
              <div className="flex items-center gap-1 relative z-10" data-id="element-229">
                {Array.from({
              length: t.stars
            }).map((_, s) => <span key={s} className="text-secondary text-lg" data-id="element-230">
                    ⭐
                  </span>)}
              </div>

              {/* Quote */}
              <p className="text-text-main text-[15px] leading-relaxed font-medium relative z-10 flex-1" data-id="element-231">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light/50 relative z-10" data-id="element-232">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center flex-shrink-0 shadow-inner" data-id="element-233">
                  <span className="text-sm font-bold text-primary" data-id="element-234">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0" data-id="element-235">
                  <p className="text-text-main font-bold text-sm" data-id="element-236">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-237">{t.role}</p>
                </div>
                <div className="ml-auto flex items-center gap-1.5 flex-shrink-0" data-id="element-238">
                  <div className="w-2 h-2 bg-check-green rounded-full shadow-[0_0_6px_rgba(16,185,129,0.6)]" data-id="element-239"></div>
                  <span className="text-text-sec text-[10px] font-bold uppercase tracking-wider" data-id="element-240">
                    Verifiziert
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Summary bar */}
        <div className="mt-10 bg-bg-alt border border-border-light rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-center" data-id="element-241">
          <div className="flex items-center gap-2" data-id="element-242">
            <span className="text-secondary text-lg" data-id="element-243">⭐⭐⭐⭐⭐</span>
            <span className="text-text-main font-bold text-lg" data-id="element-244">4.9 / 5</span>
          </div>
          <div className="h-6 w-px bg-border-light hidden sm:block" data-id="element-245"></div>
          <p className="text-text-sec font-medium text-sm sm:text-base" data-id="element-246">
            Basierend auf{' '}
            <span className="text-text-main font-bold" data-id="element-247">+1.200 Bewertungen</span>{' '}
            von verifizierten Käufern
          </p>
        </div>
      </div>
    </section>;
}